import localforage from "./localforage";
export function setToken(auth) {
    if (!auth?.id_token)
        return;
    window.localStorage.setItem('token', auth.id_token);
    window.localStorage.setItem('auth', JSON.stringify(auth));
}

export function setTheme(theme) {
    window.localStorage.setItem('darkTheme', theme);
    window.localStorage.setItem('isSystemDark', window.matchMedia('(prefers-color-scheme: dark)').matches);
    return theme
}

export function setColaborador(data) {
    window.localStorage.setItem('colaborador', JSON.stringify(data));
    return data
}

export function getColaborador() {
    return JSON.parse(window.localStorage.getItem('colaborador')) ?? {}
}

export function setColaboradorAcessos(colaboradorAcessos) {
    window.localStorage.setItem('colaboradorAcessos', JSON.stringify(colaboradorAcessos));
}

export function getColaboradorAcessos() {
    return JSON.parse(window.localStorage.getItem('colaboradorAcessos')) ?? [];
}

export function setSede(data) {
    window.localStorage.setItem('sede', JSON.stringify(data));
    return data
}

export function getSede() {
    return JSON.parse(window.localStorage.getItem('sede')) ?? {}
}

export function getTheme() {
    if (['null', null].includes(window.localStorage.getItem('darkTheme')))
        return setTheme(window.matchMedia('(prefers-color-scheme: dark)').matches);
    if(JSON.parse(window.localStorage.getItem('isSystemDark')) === window.matchMedia('(prefers-color-scheme: dark)').matches)
        return JSON.parse(window.localStorage.getItem('darkTheme'));
    return setTheme(window.matchMedia('(prefers-color-scheme: dark)').matches);
}

export function getToken() {
    return {
        token: window.localStorage.getItem('token'),
        auth: JSON.parse(window.localStorage.getItem('auth')) ?? null
    }
}

export function hasToken() {
    return !!window.localStorage.getItem('token')
}

export function removeToken() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('auth');
    window.localStorage.removeItem('colaborador');
    localforage.dropInstance();
}
